document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.js-product-card');
  
  productCards.forEach(card => {
    const dots = card.querySelectorAll('.js-color-dot');
    const img = card.querySelector('.js-product-img');
    const input = card.querySelector('.js-variant-input');

    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        dots.forEach(d => d.classList.remove('is-active'));
        dot.classList.add('is-active');

        const newImg = dot.dataset.img;
        const newId = dot.dataset.variantId;

        if (img && newImg) {
          img.style.opacity = '0';
          setTimeout(() => {
            img.src = newImg;
            img.style.opacity = '1';
          }, 200);
        }
        if (input && newId) input.value = newId;
      });
    });
  });
});